const SERVER_API_URL = process.env.SERVER_API_URL ?? "http://127.0.0.1:4000/api";
const BROWSER_API_URL = "/api";
const API_URL = typeof window === "undefined" ? SERVER_API_URL : BROWSER_API_URL;

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("Content-Type") && !(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
    cache: options.cache ?? "no-store"
  });

  if (!response.ok) {
    let message = "Không thể tải dữ liệu";
    try {
      const payload = await response.json();
      message = Array.isArray(payload.message) ? payload.message.join(", ") : payload.message ?? message;
    } catch {
      message = response.statusText;
    }
    throw new ApiError(message, response.status);
  }

  return response.json() as Promise<T>;
}

export { API_URL };

export function getPaginatedData<T>(payload: T[] | { data: T[] }) {
  return Array.isArray(payload) ? payload : payload.data;
}
